import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import {
  filterMarketplaceAddonsForOrg,
  isProductHeld,
  resolvePlanProductCopy,
} from "util/planEntitlements";
import styles from "./style.module.scss";

const SONIC_KEY = "pivony_sonic_activation";

const PlanAddonMarketplace = ({
  products = [],
  entitlements = [],
  onRequestProduct,
  loading,
  isEnterprise = false,
}) => {
  const { t } = useTranslation();
  const addons = filterMarketplaceAddonsForOrg(products, entitlements);

  if (!loading && !addons.length) {
    return null;
  }

  return (
    <div className={styles.content}>
      <h3 className={styles.header}>{t("settings.plan_addon_marketplace_title")}</h3>
      <p className={styles.sectionHint}>
        {t("settings.plan_addon_marketplace_hint")}
      </p>
      {loading ? (
        <p className={styles.sectionHint}>{t("settings.plan_loading")}</p>
      ) : null}
      <div className={styles.productGrid}>
        {addons.map((product) => {
          const key = product.product_key || product.key;
          const active = isProductHeld(key, entitlements);
          const isSonic = key === SONIC_KEY;
          const copy = resolvePlanProductCopy(key, product, t);

          return (
            <div
              key={key}
              className={`${styles.productCard} ${isSonic ? styles.productCardFeatured : ""}`}
            >
              <div className={styles.productCardHeader}>
                <h4 className={styles.productCardTitle}>{copy.name}</h4>
                {active ? (
                  <span className={styles.activeBadge}>
                    {t("settings.plan_product_active")}
                  </span>
                ) : null}
              </div>
              <p className={styles.productCardDesc}>{copy.description}</p>
              {!active ? (
                <div className={`${styles.btn} ${styles.btnBuy}`}>
                  <Button
                    onClick={() =>
                      onRequestProduct({
                        productKey: key,
                        productName: copy.name,
                      })
                    }
                  >
                    {isEnterprise
                      ? t("sonic_prospect.plans_contact_sales")
                      : t("settings.plan_product_activate")}
                  </Button>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlanAddonMarketplace;
